export default __webpack_public_path__ + "static/media/map-marker-alt.ce1e3eeb.svg";